
import isString from 'lodash/isString';

import { api } from '../services/redux-beesConfig';
import AuthService from './AuthService';
import store from '../Store'
import { getActiveLanguage } from 'react-localize-redux';

const userID = AuthService.getUserID();

class PersonalInfoService {
  static getUser(values) {
    return api.login({ locale: `${getActiveLanguage(store.getState().locale).code}`}, values)
    .then((res) => {
      if(isString(res.body.data.token)){
        this.setTokenCookie(res.body.data.token);
        return true;
        }
    }).catch(error => {
      if (error.status === 401) {
        AuthService.logOut();
      }
      throw error.body.errors[0].detail;
    });
  }
  static setTokenCookie(token) {
    localStorage.setItem('token', token);
    return true;
  }
  static changePassword (values) {
    return api.changePassword({ locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID },values)
      .then(res => res)
  }
};

export default PersonalInfoService;



// WEBPACK FOOTER //
// ./src/services/PersonalInfoService.js